import "./Kingsway04.css";
import img1 from "./../../../img/bg/bg-kingsway.png";

import location from "./../../../img/icons/location.png";
import phone from "./../../../img/icons/phone.png";

function Kingsway04() {
  return (
    <div className="Kingsway04 section">
      <div className="container">
        <div className="Kingsway04-box">
          <div className="Kingsway04-card">
            <p className="eyebrow green">KITCHENER | ONTARIO</p>
            <h2>Kingsway Drive</h2>
            <p>
              We're excited to bring the Razor King experience to Kitchener. Our
              newest location not only offers our full range of services, but
              also features an exclusive VIP room service for a private and
              elevated grooming experience.
            </p>

            <div className="divider"></div>

            <div className="Kingsway04-card-list">
              <img src={location} alt="" />
              <p>2399 Kingsway Dr #2, Kitchener, ON N2C 1A5, Canada</p>
            </div>

            <div className="Kingsway04-card-list">
              <img src={phone} alt="" />
              <p>(519) 894-2444</p>
            </div>

            <a
              href="https://bookings.gettimely.com/razorkingbarbershop1/bb/book"
              className="btn-3"
            >
              BOOK NOW
            </a>
          </div>

          <img src={img1} alt="" />
        </div>
      </div>
    </div>
  );
}

export default Kingsway04;
